import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import { Table, TableHead, TableRow, TableHeader, TableBody, Loadable } from '@ctct/ui-react';

import SMSTiersTableRow from './SMSTiersTableRow';

const SMSTiersTable = ({
  currency,
  setSelectedSMSTier,
  SMSTiers,
  contactCountLowEnd,
  selectedSMSTier,
  t,
  loading,
  initiallySelectedTierMin,
  prepayDiscountPercentage,
  allDisabled,
}) => {
  const [scrolledIntoView, setScrolledIntoView] = useState(false);
  const [allDecimalPriceZero, setAllDecimalPriceZero] = useState(false);

  const platformExpression = /Mac|iPhone|iPod|iPad/i;
  const rejectedExpression = /Chrome|Android|CriOS|FxiOS|EdgiOS/i;
  const expectedExpression = /Safari/i;

  const isAppleSafari = () => {
    const agent = navigator.userAgent;

    if (rejectedExpression.test(agent)) {
      return false;
    }

    return platformExpression.test(agent) && expectedExpression.test(agent);
  };

  useEffect(() => {
    setAllDecimalPriceZero(
      !SMSTiers.some((tier) => {
        return (tier.price * prepayDiscountPercentage) % 1 !== 0;
      })
    );
  }, [SMSTiers, prepayDiscountPercentage]);

  return (
    <div className="sms-tiers-table-v2">
      <span className={isAppleSafari() ? 'on-safari' : ''}>
        <div className="sms-tiers-table-v2 sms-tier-table-border">
          <Loadable loading={loading}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeader scope="col" className="sms-column1">
                    {t('sms-plans.select-header')}
                  </TableHeader>
                  <TableHeader scope="col">{t('sms-plans.number-of-messages-header')}</TableHeader>
                  <TableHeader scope="col">{t('sms-plans.price-month-header')}</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {SMSTiers.map(({ tierMin, tierMax, price }) => (
                  <SMSTiersTableRow
                    key={`sms-row-${tierMin}`}
                    min={tierMin}
                    max={tierMax}
                    price={price}
                    prepayDiscountPercentage={prepayDiscountPercentage || 1}
                    initiallySelectedTier={initiallySelectedTierMin != null && initiallySelectedTierMin === tierMin}
                    selectedSMSTierMin={selectedSMSTier ? selectedSMSTier.min : -1}
                    selectTierCallback={setSelectedSMSTier}
                    currency={currency}
                    isDisabled={allDisabled}
                    contactCountLowEnd={contactCountLowEnd}
                    scrolledIntoView={scrolledIntoView}
                    priceAllZeroDecimal={allDecimalPriceZero}
                    setScrolledIntoView={setScrolledIntoView}
                    visibleTableRow
                    t={t}
                  />
                ))}
              </TableBody>
            </Table>
          </Loadable>
        </div>
      </span>
    </div>
  );
};

SMSTiersTable.defaultProps = {
  loading: false,
  initiallySelectedTierMin: null,
  allDisabled: false,
  selectedSMSTier: null,
  prepayDiscountPercentage: 0,
};

SMSTiersTable.propTypes = {
  t: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  contactCountLowEnd: PropTypes.number.isRequired,
  setSelectedSMSTier: PropTypes.func.isRequired,
  selectedSMSTier: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number,
    price: PropTypes.number,
  }),
  initiallySelectedTierMin: PropTypes.number,
  prepayDiscountPercentage: PropTypes.number,
  SMSTiers: PropTypes.arrayOf(
    PropTypes.shape({
      tierMin: PropTypes.number.isRequired,
      tierMax: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  loading: PropTypes.bool,
  allDisabled: PropTypes.bool,
};

export default SMSTiersTable;
